import { Icon } from "@src/components/ui-kit/Icon";
import { ButtonLink } from "@src/components/ui-kit/Link";
import type React from "react";
import type { FC } from "react";

interface Props {
  url?: string | null;
}

export const DownloadInvoiceButton: FC<React.PropsWithChildren<Props>> = ({
  url,
  children,
}) => {
  return (
    <ButtonLink
      isExternal
      colorScheme="grey"
      variant="outline"
      href={url || ""}
      isDisabled={!url}
      leftIcon={<Icon name="download-02" />}
      size="sm"
    >
      {children}
    </ButtonLink>
  );
};
